import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import { reduxForm } from 'redux-form';
import Loader from '../../../../common/Loader';
import FormFooter from '../../../../common/forms/FormFooter';
import {
  getYangoCancelationInfo,
  clearYangoCancelationInfo,
} from '../../../../../actions';

export const YangoCancelationClaimForm = ({
  handleSubmit,
  deliveryId,
  loading,
  onSubmit,
  yangoCancelationClaimInfo,
  dispatchGetYangoCancelationInfo,
  dispatchClearYangoCancelationInfo,
}) => {
  useLayoutEffect(() => {
    dispatchGetYangoCancelationInfo({ deliveryId });

    return () => dispatchClearYangoCancelationInfo();
  }, [deliveryId]);

  if (loading || yangoCancelationClaimInfo.isEmpty()) {
    return <Loader />;
  }

  const info = yangoCancelationClaimInfo.toJS();

  const onHandleSubmit = () => {
    onSubmit({ cancelState: info.cancel_state });
  };

  const renderPriceInfo = () => {
    if (info.cancel_state === 'unavailable') {
      return (
        <div className="alert alert-warning">
          Esta entrega <strong>no se puede cancelar</strong> en este momento.
        </div>
      );
    }

    if (info.cancel_state === 'free' || !info.price) {
      return <p>Esta cancelación no tiene costo.</p>;
    }

    return (
      <p>
        El costo de cancelación es: <strong>{info.price}</strong>
      </p>
    );
  };

  return (
    <>
      <h2>Cancelar Entrega Yango</h2>
      <Form onSubmit={handleSubmit(onHandleSubmit)}>
        <div className="mb-3">
          <h4>¿Estás seguro de que deseas cancelar esta entrega?</h4>
          {renderPriceInfo()}
        </div>
        <FormFooter
          saveButtonText="CONFIRMAR CANCELACIÓN"
          saveButtonDisabled={loading || info.cancel_state === 'unavailable'}
          saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-times'}
        />
      </Form>
    </>
  );
};

YangoCancelationClaimForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  deliveryId: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  yangoCancelationClaimInfo: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchGetYangoCancelationInfo: PropTypes.func.isRequired,
  dispatchClearYangoCancelationInfo: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

YangoCancelationClaimForm.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ CargoUnit }) => ({
  loading: !CargoUnit.Delivery.getIn(['yango', 'activity']).isEmpty(),
  yangoCancelationClaimInfo: CargoUnit.Delivery.getIn(['yango', 'cancelation']),
});

const mapDispatchToProps = {
  dispatchGetYangoCancelationInfo: getYangoCancelationInfo,
  dispatchClearYangoCancelationInfo: clearYangoCancelationInfo,
};

const formComponent = reduxForm({
  form: 'YangoCancelationClaimForm',
})(YangoCancelationClaimForm);

export default connect(mapStateToProps, mapDispatchToProps)(formComponent);
